import { PaymentMethods } from 'components/molecules/Blocks/PaymentMethodBlock/PaymentMethodBlock.view';

export const formatCommandStatus = (value: string) => {
  switch (value) {
    case 'ANNULE':
      return 'Annulé';
    case 'PAYE':
      return 'Payé';
    case 'A_PAYER':
      return 'Non Payé';
    case 'NON_PAYE':
      return 'Non Payé';
    case 'A_FINALISER':
      return 'Non Finalisé';
    default:
      return value;
  }
};

export const formatCommandMethodePaiement = (
  value: PaymentMethods | string
) => {
  switch (value) {
    case 'cb':
      return 'Carte bancaire';
    case 'cheque':
      return 'Chèque';
    case 'especes':
      return 'Espèces';
    case 'mandat_administratif':
      return 'Mandat administratif';
    case 'virement':
      return 'Virement';
    default:
      return value;
  }
};
